import styled, { css } from "styled-components";

import {
  A as SitesparkA,
  Button as SitesparkButton,
  Link as SitesparkLink,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";
import {
  // getBaseFont,
  getFontFamily,
  getSize,
  // hexToRgba,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const callToActionCss = css`
  ${({
    theme: {
      colors: { darkGrey, white, yellow },
    },
  }) => `
    background-color: ${white};
    border-color: ${yellow};
    color: ${darkGrey};
  `}
  border-radius: 7px;
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  font-size: 14px;
  letter-spacing: 0.42px;
  line-height: 14px;
  min-width: 171px;
  padding: 13px 24px;
  text-align: center;
  text-transform: uppercase;
  @media screen and (min-width: ${getSize("tablet720")}) {
    /* border-width: 2px; */
    padding: 12px 23px;
  }
`;

export const aStyles = css`
  ${callToActionCss}
  white-space: nowrap;
  :active,
  :focus,
  :hover {
    text-decoration: none;
  }
`;

export const Link = styled(SitesparkLink)([""], aStyles);

export const A = styled(SitesparkA)([""], aStyles);

export const Button = styled(SitesparkButton)`
  ${callToActionCss}
  ${getFontFamily("regular")}
`;
